module.exports = __webpack_public_path__ + "img/highShot.2df0be08.png";